import React,{useState,useEffect} from 'react'


const HeaderMenuContent = ({ float = ""}) => {
  const [displayDropDownMenu, setDisplayDropDownMenu] = useState(false); 
 
  const closeDropDownMenu = () => {
    setDisplayDropDownMenu(false);
  };
   
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        displayDropDownMenu &&
        !e.target.closest(".your-dropdown-menu-class") &&
        !e.target.closest(".button_account")
      ) {
        closeDropDownMenu();
      }
    };
    // Adicione o evento de clique no documento
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [displayDropDownMenu]);

  return (
    <>
    <ul
      id="respMenu"
      className="ace-responsive-menu text-end d-lg-block d-none"
      data-menu-style="horizontal"
    >
      <li className="dropitem">
        <a
          href="#comofunciona"
        >
          <span className="title fz-span-1220">Como funciona</span>
        </a>
      </li>
      <li className="dropitem" style={{marginRight:"30px"}}>
        <a
          href="#beneficios"
        >
          <span className="title fz-span-1220">Benefícios</span>
        </a>
      </li>
      {/* End .dropitem */}
    </ul>  
    </>
  );
}

export default HeaderMenuContent
